import React, { FC, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { useDispatch } from 'react-redux';

import { verifyToken } from '~/api/auth';
import { auth, pushToLogin } from '~/api/axios';
import { loadProfiles } from '~/slices/ui';

import theme from '~/theme';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
// import { useIdentityUsePermissionsUseVerifyToken } from '~/hooks/identity';

const MainLayout: FC = (props) => {
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.md });

  // useIdentityUsePermissionsUseVerifyToken();

  const dispatch = useDispatch();

  const [isReady, setReady] = useState<boolean>(false);

  useEffect(() => {
    const verify = async () => {
      try {
        await verifyToken();
        dispatch(
          loadProfiles(() => {
            setReady(true);
          })
        );
      } catch (error: any) {
        pushToLogin();
      }
    };

    if (auth.getToken() && auth.getProfile()) {
      void verify();
    } else {
      pushToLogin();
    }
  }, [dispatch]);

  return isReady && auth.getProfile() ? (
    isTablet ? (
      <MobileLayout {...props} />
    ) : (
      <DesktopLayout {...props} />
    )
  ) : null;
};

export default MainLayout;
